function initThreeLogo() {
  var container = document.getElementById('three-logo-container');
  var canvas = document.getElementById('three-logo-canvas');
  var fallback = document.getElementById('three-logo-fallback');
  if (!container || !canvas) return;

  function hasWebGL() {
    try {
      var testCanvas = document.createElement('canvas');
      var gl = testCanvas.getContext('webgl') || testCanvas.getContext('experimental-webgl');
      return !!gl;
    } catch(e) {
      return false;
    }
  }

  if (!hasWebGL() || typeof THREE === 'undefined') {
    if (fallback) fallback.style.display = 'flex';
    return;
  }

  if (fallback) fallback.style.display = 'none';
  canvas.style.display = 'block';

  var width = container.offsetWidth || 288;
  var height = container.offsetHeight || 56;

  var scene = new THREE.Scene();
  var camera = new THREE.PerspectiveCamera(45, width / height, 0.1, 100);
  camera.position.set(0, 0, 3.2);

  var renderer = new THREE.WebGLRenderer({ canvas: canvas, alpha: true, antialias: true, preserveDrawingBuffer: true });
  renderer.setSize(width, height);
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.setClearColor(0x000000, 0);

  var ambientLight = new THREE.AmbientLight(0xffffff, 1.5);
  scene.add(ambientLight);
  var dirLight1 = new THREE.DirectionalLight(0xffffff, 2);
  dirLight1.position.set(10, 10, 10);
  scene.add(dirLight1);
  var dirLight2 = new THREE.DirectionalLight(0xffffff, 1);
  dirLight2.position.set(-10, -10, -10);
  scene.add(dirLight2);

  var logoSrc = fallback ? fallback.querySelector('img').src : '';
  var textureLoader = new THREE.TextureLoader();

  textureLoader.load(logoSrc, function(texture) {
    texture.anisotropy = renderer.capabilities.getMaxAnisotropy();
    texture.minFilter = THREE.LinearMipmapLinearFilter;
    texture.magFilter = THREE.LinearFilter;
    texture.generateMipmaps = true;
    var aspect = texture.image.width / texture.image.height;
    var planeWidth = 4;
    var planeHeight = planeWidth / aspect;

    var group = new THREE.Group();
    var layers = 8;
    var thickness = 0.015;

    for (var i = 0; i < layers; i++) {
      var geometry = new THREE.PlaneGeometry(planeWidth, planeHeight);
      var material = new THREE.MeshStandardMaterial({
        map: texture,
        transparent: true,
        alphaTest: 0.2,
        side: THREE.DoubleSide
      });
      var mesh = new THREE.Mesh(geometry, material);
      mesh.position.z = (i - layers / 2) * thickness;
      group.add(mesh);
    }

    scene.add(group);

    var clock = new THREE.Clock();
    function animate() {
      requestAnimationFrame(animate);
      var delta = clock.getDelta();
      group.rotation.y += delta * 0.5;
      renderer.render(scene, camera);
    }
    animate();

    window.addEventListener('resize', function() {
      var w = container.offsetWidth;
      var h = container.offsetHeight;
      camera.aspect = w / h;
      camera.updateProjectionMatrix();
      renderer.setSize(w, h);
    });
  }, undefined, function() {
    if (fallback) fallback.style.display = 'flex';
    canvas.style.display = 'none';
  });
}

if (document.readyState === 'complete') {
  initThreeLogo();
} else {
  window.addEventListener('load', initThreeLogo);
}
